// bao migrate skip
import TabPage from "./tab-page";
import BaseViewModel2 from "./base-view-model2";
import GenericListTab from "./generic-list-tab";
import * as ko from "knockout";
import ConfigurationItemAuditDialog from "./configuration-item-audit-dialog";
abstract class GenericListTabHistory extends GenericListTab {
    PermissionAuditTrail: string;
    ToolbarClickBase: any;
    constructor(tabPage: TabPage, parent: BaseViewModel2) {
        super(tabPage, parent);
        this.BindingToolbar = {
            buttons: this.ToolbarButtons,
            click: this.ToolbarClickHistory,
            toolbarName: this.ToolbarName,
            formName: null,
            applicationId: null
        };
    }
    ToolbarClickHistory = (button: Interfaces.Bao.BaoMenuItem) => {
        this.ToolbarClick(button);
        var key = ko.unwrap(button.ActionKey);
        switch (key) {
            case this.PermissionAuditTrail:
                this.AuditTrail();
                break;
        }
    };
    UrlAuditTrail(): string {
        return this.ControllerUrl + "/CreateAuditTrail";
    }
    UrlAuditTrailOverview(): string {
        return this.ControllerUrl + "/CreateAuditTrailOverview";
    }
    /**
     * returns null if it is not possible to get an id
     */
    GetFirstSelectedId() {
        if (ko.unwrap(this.Selection) != null && ko.unwrap(this.Selection).length > 0) {
            // usually Selection is of type BusinessModel[] and has prop PrimaryKeyValue
            return ko.unwrap(this.Selection()[0].PrimaryKeyValue);
        }
        return null;
    }
    AuditTrail(): any {
        let auditDialog: ConfigurationItemAuditDialog = null;
        // switch between detail view on selected or overview because nothing is selected
        // if something is selected => detail
        if (this.GetFirstSelectedId() !== null) {
            auditDialog = new ConfigurationItemAuditDialog(this.GetFirstSelectedId(), ko.unwrap(this.TabPage.Title), this.TabPage, this.UrlAuditTrail());
        }
        // nothing selected => overview
        else {
            auditDialog = new ConfigurationItemAuditDialog(this.GetParentId(), ko.unwrap(this.TabPage.Title), this.TabPage, this.UrlAuditTrailOverview(), true);
        }
        auditDialog.Open();
    }
    ToggleToolbarButtons() {
        super.ToggleToolbarButtons();
        ko.utils.arrayForEach(this.ToolbarButtons(), (button) => {
            var key = ko.unwrap(button.ActionKey);
            var enabled = <KnockoutObservable<boolean>>(button.Enabled);
            // keiner oder eins
            if (key == this.PermissionAuditTrail) {
                enabled(this.Selection() == null || this.Selection().length <= 1);
            }
        });
    }
    init() {
        var def = $.Deferred<any>();
        super.init().then((result: any) => {
            this.PermissionAuditTrail = result.Definition.FormName + "AuditTrail";
            def.resolve();
        });
        return def.promise();
    }
}
export default GenericListTabHistory;